import { useState, useEffect } from 'react';
import { FiDownload } from 'react-icons/fi';
import './InstallButton.css';

let deferredPrompt = null;

function InstallButton() {
  const [canInstall, setCanInstall] = useState(!!deferredPrompt);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      setCanInstall(true);
    };

    const onInstalled = () => {
      deferredPrompt = null;
      setCanInstall(false);
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      deferredPrompt = null;
      setCanInstall(false);
    }
  };

  if (!canInstall) return null;

  return (
    <button className="install-btn-installbutton" onClick={handleInstall} title="Instalar aplicación">
      <FiDownload />
      <span className="install-text-installbutton">Instalar App</span>
    </button>
  );
}

export default InstallButton;
